/**
 * Pure private-room configuration rules: map presets and the authoritative
 * combination validation. Kept here (no protocol dependency) so the realtime
 * server validates and the client previews with identical logic.
 */
/**
 * Map presets. The large map matches the official arena; smaller maps cap the
 * entity count harder to avoid crowding (small 8, medium 16, large 30).
 */
export const ROOM_MAP_PRESETS = {
    small: { arenaRadius: 1280, entityCap: 8 },
    medium: { arenaRadius: 2000, entityCap: 16 },
    large: { arenaRadius: 2880, entityCap: 30 },
};
export function getRoomMapPreset(mapSize) {
    return ROOM_MAP_PRESETS[mapSize];
}
/**
 * Validates a private-room configuration combination:
 * - the total entity limit must fit the chosen map;
 * - bots must leave room for at least two humans (the host and one guest).
 */
export function validatePrivateRoomConfig(config) {
    const preset = ROOM_MAP_PRESETS[config.mapSize];
    if (config.playerLimit > preset.entityCap) {
        return { ok: false, reason: "player_limit_exceeds_map" };
    }
    if (config.botCount > config.playerLimit - 2) {
        return { ok: false, reason: "bots_exceed_player_limit" };
    }
    return { ok: true };
}
